module.exports = __webpack_public_path__ + "assets/img/goods-customized.60cc14eb.png";